import { combineReducers } from "redux";
import LoginReducer from "../containers/Login/reducer";
import RouterReducer from "../Router/reducer";
import MainReducer from "../containers/Main/reducer";
import { createBrowserHistory } from "history";
import { connectRouter } from "connected-react-router"; // import { reducers as VRCoreReducers } from "../client/VRCore";

export var history = createBrowserHistory();
var rootReducer = combineReducers({
  LoginReducer: LoginReducer,
  RouterReducer: RouterReducer,
  MainReducer: MainReducer,
  router: connectRouter(history) // ...VRCoreReducers

});
export default rootReducer;